/* globals $H,Ajax,Class,jui */
var jQuery = require('jquery');
var rxUi     = window.rxUi;
var _ = require('lodash');

var endpoints = require('ub/config/endpoints').default;
var AssetView = require('ub/lp/editor/ub-asset-view');

module.exports = Class.create(jui.TabView, {
  options: function($super,options){
    return $super($H({
      classNames:['asset-browser','modal-asset-browser'],
      viewType: 'grid',
      selectedTab: 'images',
      assetTypes: {
        images: ['image'],
        documents: ['application', 'text'],
        media: ['video', 'audio'],
        other: ['other']
      }
    }).merge(options));
  },

  initialize: function($super, options){
    $super(options);
    this.assetsLoaded = false;
    this.openAssetsCompanyId = window.editor.currentCompanyId;
    this.viewType = this.options.viewType;
    this.e.addClassName(this.viewType);
    this.assets = [];
    this.loadCompleteCallback = null;
  },

  installUI: function($super) {
    $super();
    this._uiBinding = new rxUi.Binding(['AssetBrowser']);

    var self = this;

    _(this.options.assetTypes)
      .keys()
      .each(function(assetType) {
        var view = new AssetView({
          name:assetType,
          onMassDelete: this.deleteSelectedAssets.bind(this)
        });

        this.addAssetViewListeners(view);

        this.addTabViewItem({
          id: assetType,
          label: assetType.capitalize(),
          view: view
        });

      }, this);

    var loadingOverlay = new jui.ModalSheet({attributes: {className: 'modal-sheet loading-overlay'}});
    loadingOverlay.insertContent(
      jQuery(
        '<div class="loading-container">' +
          '<div class="loading-icon"></div>' +
          '<div class="loading-title">Opening ' +
          '<span class="js-librarytype">asset library</span>...</div>'+
          '</div>'
      )[0]
    );
    loadingOverlay.open(this);

    this.deleteDialog = new jui.ModalSheet({attributes: {className: 'modal-sheet asset-delete'}});

    this.deleteDialog.insertContent(jQuery('<div class="warning-header-icon svg-ico-warning4"></div>')[0]);
    this.deleteDialog.insertContent(jQuery('<div class="warning-header-title">Delete Assets</div>')[0]);

    this.deleteDialogMessage = this.deleteDialog.insertContent(new jui.Component({classNames:['warn']}));

    this.deleteDialogActions = this.deleteDialog.insertContent(new jui.Component({classNames:['delete-actions']}));

    this.deleteDialogOkButton = this.deleteDialogActions.insert( new jui.Button({classNames: ['delete', 'modal-button'], label: 'Yes, Delete' }));
    this.deleteDialogCancelButton = this.deleteDialogActions.insert( new jui.Button({classNames: ['cancel', 'modal-button'], label:'Cancel', action: function() {
      self.deleteDialog.close();
      self.enable();
    }}));


    this.deleteDialog.insertContent(jQuery('<div class="caution">Caution: This cannot be undone.</div>')[0]);

    this._uiBinding
      .filterByEventType('selectTab')
      .ub_subscribe(function(ev) {
        self.tabSelected(ev.tab);
      });
  },

  selectTab: function(id) {
    this._uiBinding.onNext({type: 'selectTab',tab: id});
  },

  addAssetViewListeners: function(view) {
    view.addListener('assetSelectionChanged', this);
    view.addListener('companyFilterChanged', this);
    view.addListener('assetDeleteClicked', this);
  },

  enable: function() {
    this.fireEvent('enabled');
  },

  disable: function() {
    this.fireEvent('disabled');
  },

  clear: function() {
    if (this.enabled) {
      this.enable();
    }

    if (this.deleteDialog.isOpen()) {
      this.deleteDialog.close();
    }

    this.getViews().invoke('clear');
  },

  tabSelected: function($super, id) {
    $super(id);
    this._setCurrentDeleteButtonStatus();

    var view = this.getSelectedView();
    view.unveilImages();
  },

  prepareViews: function() {
    this.getViews().invoke('prepareForLoading');
  },

  setImagesOnly: function() {
    this.options.assetTypes = {images: [ "image" ]};
  },

  loadAssetsByCompanyId: function(companyId, options) {
    options = options || {};
    var self = this;
    var url  = endpoints.assetsByCompanyId(companyId);

    this.assetsLoaded = false;
    this.prepareViews();
    this.loadCompleteCallback = options.onComplete || null;

    var cacheKey = 'assets'+companyId; // +'/images'
    var cached = window.localStorage.getItem(cacheKey);
    if (cached) {
      var data = JSON.parse(cached);
      if (Date.parse(data.timestamp) >
          ((new Date()).getTime() - (60*5*1000)) ) {
        var assets = data.assets;
        this.loadAssetsSuccess.bind(this, assets, companyId).defer(0);
        this.openAssetsCompanyId = companyId;
        return null;
      }
    }

    return new Ajax.Request(url, {
      method: 'get',
      contentType:'application/json',
      onSuccess: function(transport) {
        var assets = transport.responseJSON;
        self.loadAssetsSuccess.bind(self, assets, companyId).defer(0);
        self.openAssetsCompanyId = companyId;
        window.localStorage.setItem(
          cacheKey, JSON.stringify({assets: assets,
                                    timestamp: new Date()}));
      }
    });
  },

  loadAssetsSuccess: function(data, companyId) {
    var sort = this.getDefaultSortOrderByCompanyId(companyId),
        types = $H(this.options.assetTypes),
        groupedAssets = {};

    this.assetsLoaded = true;
    var view = this.getViews().first();
    this.assets = view.sortAssets(data, sort.name, sort.direction);

    types.keys().each( function(k) {
      groupedAssets[k] = [];
    });

    groupedAssets.other = [];

    this.assets.each( function(a) {
      var grouped = false;
      types.each( function(pair) {
        if (pair.value.any( function(v) {return a.content_content_type.startsWith(v); })){
          groupedAssets[pair.key].push(a);
          grouped = true;
        }
      });

      if (!grouped) {
        groupedAssets.other.push(a);
      }
    }, this);

    $H(groupedAssets).each( function(group) {
      var name = group.key === 'other' ?
        'other files' :
        group.key === 'media' ?
        'media files' :
        group.key;

      this.getView(group.key).loadAssets(group.value, name, this.openAssetsCompanyId);
      var tab = this.getTab(group.key);
      tab.setLabel(tab.options.label +' ('+group.value.length+')');
    }, this);

    if (this.loadCompleteCallback !== null) {
      this.loadCompleteCallback();
    }
    view.sortFilter.selectById(sort.name);
    this.fireEvent('assetsLoaded');
  },

  getDefaultSortOrderByCompanyId: function(id) {
    if(this.isUnbounceAssetCompany(id)) {
      return {name:'content_file_name', direction: 'ASC'};
    } else {
      return {name:'id', direction: 'DSC'};
    }
  },

  isUnbounceAssetCompany: function(id) {
    return parseInt(id, 10) === parseInt(window.editor.unbounceAssetsCompanyId, 10);
  },

  addAsset: function(asset) {
    this.assets.unshift(asset);
    var types = $H(this.options.assetTypes);
    var id = 'other';
    types.each( function(pair) {
      if (pair.value.any( function(v) {return asset.content_content_type.startsWith(v); })) {
        id = pair.key;
      }
    });
    this.getView(id).addAsset(asset);
    this.updateSelectedTabCounter();
  },

  showTabWithContentType: function(contentType) {
    var types = $H(this.options.assetTypes);

    var result = types.find( function(pair) {
      return pair.value.any( function(v) {return contentType.startsWith(v); });
    });

    if (result) {
      var id = result[0];
      if (this.getTab(id).visible()) {
        this.setTabViewItem(id);
      } else {
        // console.log('tab not visible');
      }
    }
  },

  setVisibleTabs: function(tabIds) {
    this.tabs.values().invoke('hide');
    this.tabs.each( function(pair) {
      if (tabIds.indexOf(pair.key) > -1) {
        pair.value.show();
      }
    });
  },

  companyFilterChanged: function(e) {
    this.e.addClassName('loading');
    this.switchViewByCompanyId(e.data);
  },

  switchViewByCompanyId: function(companyId) {
    this.openAssetsCompanyId = companyId;
    this.loadAssetsByCompanyId(companyId);
    this._setCurrentDeleteButtonStatus();
  },

  isDeleteButtonEnabled: function() {
    return this.getSelectedAssets().length > 0 &&
      this.getViews().first().isManageable();
  },

  getSelectedView: function() {
    return this.selectedTabViewItem.view;
  },

  getSelectedAsset: function() {
    return this.getSelectedAssets()[0];
  },

  getSelectedAssets: function() {
    return this.getSelectedView().selectedAssets;
  },

  getUpdatedAsset: function() {
    return this.getSelectedView().asset;
  },

  assetSelectionChanged: function(e) {
    this._setCurrentDeleteButtonStatus();
    this.fireEvent('assetSelectionChanged', e.data);
  },

  assetDeleteClicked: function(e) {
    this.confirmDeleteAssets([e.data]);
  },

  deleteSelectedAssets: function() {
    this.confirmDeleteAssets(this.getSelectedAssets());
  },

  confirmDeleteAssets: function(assets) {
    var message = '<p class="warn-message">Are you sure you want to delete the following assets?</p><ul class="delete-file-list">';
    var self = this;

    assets.each(function(asset) {
      message += '<li>'+asset.name + '</li>';
    });


    message += '</ul>';

    this.deleteDialogMessage.update(message);

    this.deleteDialogOkButton.setAction(function() {
      self.deleteDialog.close();
      self.enable();
      self.deleteAssets(assets);
    });

    this.disable();
    this.deleteDialog.open(this);
  },

  deleteAssets: function(assets) {
    var url      = endpoints.deleteAssets(this.openAssetsCompanyId);
    var postBody = assets.collect( function(asset) {return 'assets[]='+asset.id;}).join('&');
    var self     = this;

    return new Ajax.Request(url, {
      method: 'post',
      postBody: postBody,
      onSuccess: function( transport ) {
        self.deleteAssetsSuccess.bind( self, transport.responseJSON ).defer();
        window.localStorage.removeItem("assets" + window.editor.currentCompanyId);
      }
    });
  },

  deleteAssetsSuccess: function(data) {
    this.getSelectedView().removeAssetsById(data.collect( function(id) {return Number(id);}));
    this.getSelectedView().buildSearch();
    this.updateSelectedTabCounter();
  },

  updateSelectedTabCounter: function() {
    var tvi  = this.selectedTabViewItem;
    var tab  = this.getTab(tvi.id);
    var view = tvi.view;

    tab.setLabel(tab.options.label +' ('+view.assets.length+')');
  },

  clearSelection: function() {
    this.selectedTabViewItem.view.clearSelection();
  },

  _setCurrentDeleteButtonStatus: function() {
    // Set the enabled status of the delete button on the currently displayed view
    var currentView = this.getSelectedView();

    if( ! _.isEmpty(currentView) && currentView.massDeleteButton) {
      currentView.massDeleteButton.setEnabled(this.isDeleteButtonEnabled());
    }
  }
});



// WEBPACK FOOTER //
// ./src/lp/editor/ub-asset-browser.js